// libs
import React, { memo } from 'react';

// Global Components
import ResponsiveLoader from 'shared/components/ResponsiveLoader';

// local Components
import { PlaceHolderMobile, PlaceHolderDesktop } from './components';

// Constants
import { BREAKPOINTS } from 'shared/styles/base';

function Placeholder() {
  return (
    <>
      <ResponsiveLoader breakpoint={BREAKPOINTS.DESKTOP} down>
        <PlaceHolderMobile />
      </ResponsiveLoader>
      <ResponsiveLoader breakpoint={BREAKPOINTS.DESKTOP} up>
        <PlaceHolderDesktop />
      </ResponsiveLoader>
    </>
  );
}

export default memo(Placeholder);
